import React, { useState } from "react";
import { Alert, Form, Toast } from "react-bootstrap";

import DstButton from "../../../../components/DstButton/DstButton";
import Popup from "../../../../components/Popup/Popup";
import translate from "../../../../services/Translate";
import { CreateCustomFilterPopupProps } from "./CreateCustomFilterPopup.d";

const CreateCustomFilterPopup = ({ closeModal, language, show, currentFilters }: CreateCustomFilterPopupProps) => {
  const [name, setName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const _createNewFilter = () => {
    const customFilterName = name.trim();
    if (!customFilterName) return;

    try {
      const existingFilters = JSON.parse(localStorage.getItem("nexus-custom-filters-meetings") || "{}");

      if (Object.keys(existingFilters).some((key) => key.toLowerCase() === customFilterName.toLowerCase())) {
        setErrorMessage(translate(language, "PAGES.MEETINGS.FILTERS.MODAL.ERRORS.NAME_EXISTS"));
        return;
      }

      const updatedFilters = {
        ...existingFilters,
        [customFilterName]: {
          meetingTypes: currentFilters.meetingTypes,
          authors: currentFilters.authors,
          animators: currentFilters.animators,
          programs: currentFilters.programs,
          languages: currentFilters.languages,
        },
      };

      localStorage.setItem("nexus-custom-filters-meetings", JSON.stringify(updatedFilters));

      setName("");
      setShowToast(true);
      setErrorMessage("");
      closeModal();
    } catch (error) {
      console.error("An error occurred with custom filters.", error);
    }
  };

  return (
    <React.Fragment>
      <Popup
        show={show}
        onClose={() => {
          setName("");
          setErrorMessage("");
          closeModal();
        }}
        modalTitle={translate(language, "PAGES.MEETINGS.FILTERS.MODAL.TITLE")}
        scrollable
        footerContent={
          <React.Fragment>
            <DstButton
              variant="secondary"
              value={translate(language, "PAGES.MEETINGS.FILTERS.MODAL.BUTTONS.CANCEL")}
              clickFunction={() => {
                setName("");
                setErrorMessage("");
                closeModal();
              }}
            />
            <DstButton
              value={translate(language, "PAGES.MEETINGS.FILTERS.MODAL.BUTTONS.CONFIRM")}
              clickFunction={_createNewFilter}
              disabled={!name.trim().length}
            />
          </React.Fragment>
        }
      >
        <Form
          id="modal-add-meetings-filter"
          onSubmit={(event) => {
            event.preventDefault();
            _createNewFilter();
          }}
        >
          <Form.Group>
            <Form.Label>{translate(language, "PAGES.MEETINGS.FILTERS.MODAL.LABELS.CREATE_CUSTOM_FILTER")}</Form.Label>
            <Form.Control
              className={`border-secondary ${!name.trim().length ? "text-muted" : ""} ${
                errorMessage ? "is-invalid" : ""
              }`}
              type="text"
              placeholder={translate(language, "PAGES.MEETINGS.FILTERS.MODAL.PLACEHOLDERS.NAME")}
              value={name}
              onChange={(event) => setName(event.target.value)}
              maxLength={100}
            />
            <div className="text-end text-muted mt-1 xs-regular">{name.length}/100</div>
            {errorMessage && (
              <Alert variant="danger" className="mt-2 py-2">
                {errorMessage}
              </Alert>
            )}
          </Form.Group>
        </Form>
      </Popup>

      <Toast
        bg="success"
        className="position-fixed top-0 end-0 m-3"
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={3000}
        autohide
      >
        <Toast.Body className="text-white">
          {translate(language, "PAGES.MEETINGS.FILTERS.MODAL.SUCCESS.CREATE_CUSTOM_FILTER")}
        </Toast.Body>
      </Toast>
    </React.Fragment>
  );
};

export default CreateCustomFilterPopup;
